import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/audioGuide/search.png';
import _imports_1 from '../../../assets/audioGuide/location.png';
const _withScopeId = n => (_pushScopeId("data-v-26df2b66"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "audioGuide"
};
const _hoisted_2 = {
  class: "searchBox"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "search-icon"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_6 = {
  class: "swiper-wrapper"
};
const _hoisted_7 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "title-box"
};
const _hoisted_10 = {
  class: "exhibition-title"
};
const _hoisted_11 = {
  class: "museum-list"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#c9b670",
    "font-size": "0.55rem"
  }
}, "|"), /*#__PURE__*/_createElementVNode("span", {
  class: "my-title"
}, "展厅列表")], -1));
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "exhibition-name"
};
const _hoisted_16 = {
  class: "type"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "eye",
  src: _imports_1
}, null, -1));
const _hoisted_18 = {
  class: "number"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
    placeholder: "名称",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputValue = $event)
  }, null, 512), [[_vModelText, $data.inputValue]]), _createElementVNode("div", {
    class: "search-icon",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.search && $options.search(...args))
  }, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannersList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.showBigImage && _ctx.showBigImage(...args)),
      src: item.bannerImage
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(item.bannerName), 1)])]);
  }), 256))])], 512), _createElementVNode("div", _hoisted_11, [_hoisted_12, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.museumList, item => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $options.showMuseumList(item),
      class: "exhibition"
    }, [_createElementVNode("img", {
      class: "exhibition-img",
      src: item.imgPath
    }, null, 8, _hoisted_14), _createElementVNode("div", _hoisted_15, _toDisplayString(item.shortName), 1), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(item.adLink), 1)]), _hoisted_19], 8, _hoisted_13);
  }), 256))])]);
}